import React from "react";
import { App, Button, message, Tooltip } from "antd";
import { MdOutlineFactCheck } from "react-icons/md";
import { useNavigate } from "react-router-dom";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const TableAction = ({ record }) => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  const navigate = useNavigate();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  const handleQC = () => {
    if (!record) return message.error("Data not found!");
    const id = record?.id;
    const href = `/bailiff/${id}`;
    console.log({ href });
    navigate(href, { replace: true });
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Tooltip title="Bắt đầu QC">
      <Button
        onClick={handleQC}
        icon={
          <span className="anticon">
            <MdOutlineFactCheck />
          </span>
        }
      />
    </Tooltip>
  );
};
export default TableAction;
